import React from 'react';
import ReactDOM from 'react-dom';
import Widget from './components/Widget';
import * as serviceWorker from './core/bin/serviceWorker';
import { IntlProvider } from 'react-intl';
import i18n from './core/bin/i18n.js';
import { flattenMessages } from './utils'

import './index.scss';


/**
 * Renders the widget.
 *
 * It renders a react application as the widget.
 *
 * @param {string} instanceId
 *   The already present HTML element ID where the react app will be rendered.
 * @param {string} langCode
 *   The language code for internationalization purposes.
 * @param {string} origin
 *   Protocol and hostname where a JSONAPI endpoint is available.
 * @param {Function} cb
 *   A callback that executes after the widget has been rendered.
 */
function render(instanceId, langCode, origin, cb) {
  const element = document.getElementById(instanceId);
  const getCMSLocaleCode = element.getAttribute('data-localecode') || '';

  let translation = new i18n(langCode || serviceWorker.getUrlLocale());
  if (!translation.messages) {
    translation = new i18n('en');
  }
  ReactDOM.render(
    <IntlProvider
      locale={translation.locale}
      messages={flattenMessages(translation.messages)}>
      <Widget cmsLocale={getCMSLocaleCode} />
    </IntlProvider>,
    element,
    () => cb(element),
  );
  serviceWorker.unregister();
}

window.renderJourneyAiWidget = render;
